import instance from "./instance";

const achievementUr = "/practice/v1/user/user-achievement";

export const getAllAchievement = () => {
  // checkAndCallDailyLoginAPI()
  return instance.get(`${achievementUr}/get-all-achievements`);
};
